// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delivery-convincer{padding:2rem 10px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;align-items:center}.delivery-convincer .sgi{font-size:2.5em;line-height:40px}.delivery-convincer .shipping-timer{padding-left:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
